import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';


const FPSMenuDetails = () => {
    const [districts, setDistricts] = useState([]);
    const [fpsList, setFpsList] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedFps, setSelectedFps] = useState('');
    const [menus, setMenus] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [updateMessage, setUpdateMessage] = useState('');

    useEffect(() => {
        fetchDistricts();
    }, []);

    const fetchDistricts = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/menus/districts`);
            setDistricts(response.data);
        } catch (error) {
            console.error('Error fetching districts:', error);
        }
    };

    const fetchFpsByDistrict = async (distCode) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/menus/fps?distCode=${distCode}`);
            setFpsList(response.data);
        } catch (error) {
            console.error('Error fetching FPS:', error);
        }
    };

    const handleDistrictChange = (e) => {
        const distCode = e.target.value;
        setSelectedDistrict(distCode);
        setSelectedFps('');
        if (distCode) {
            fetchFpsByDistrict(distCode);
        } else {
            setFpsList([]);
        }
    };

    const handleFpsChange = (e) => {
        setSelectedFps(e.target.value);
    };

    const fetchMenuReport = async () => {
    setLoading(true);
    setMessage('');
    setMenus([]);
    try {
        const params = {};
        if (selectedDistrict) params.distCode = selectedDistrict;
        if (selectedFps) params.fpsId = selectedFps;

        const response = await axios.get(`${process.env.REACT_APP_URL}/api/menus/report`, { params });

        if (!response.data || !response.data.menus || response.data.menus.length === 0) {
            setMenus([]);
            setMessage('No data available');
        } else {
            setMenus(response.data.menus);
            setMessage(response.data.message || '');
        }
    } catch (error) {
        console.error('Error fetching menu report:', error);
        setMessage('Failed to fetch data');
    } finally {
        setLoading(false);
    }
};


    const handleStatusChange = (index, newStatus) => {
        const updatedMenus = [...menus];
        updatedMenus[index].status = newStatus;
        setMenus(updatedMenus);
    };

    const handleSubmit = async () => {
        try {
            const requestData = {
                distCode: selectedDistrict,
                fpsId: selectedFps,
                menuStatuses: menus.map(menu => ({
                    slno: menu.slno,
                    status: menu.status
                }))
            };

            const response = await axios.post(`${process.env.REACT_APP_URL}/api/menus/update`, requestData);
            setUpdateMessage(response.data);
            alert(response.data);
        } catch (error) {
            console.error('Error updating menu status:', error);
            setUpdateMessage('Error updating menu status');
        }
    };

    return (
        <div className="container">
            <table align="center" border="1">
                <tr className="tableheader">
                    <td colSpan={4}>Menu Details</td>
                </tr>
                <tr >
                    <td>District</td>
                    <td><select 
                    className="form-control" 
                    value={selectedDistrict} 
                    onChange={handleDistrictChange}
                >
                    <option value="">-- All --</option>
                    {districts.map(district => (
                        <option key={district.code} value={district.code}>
                            {district.name}
                        </option>
                    ))}
                </select></td>
                    <td>FPS</td>
                    <td><select 
                    className="form-control" 
                    value={selectedFps} 
                    onChange={handleFpsChange}
                    disabled={!selectedDistrict}
                >
                    <option value="">-- All --</option>
                    {fpsList.map(fps => (
                        <option key={fps.code} value={fps.code}>
                            {fps.name}
                        </option>
                    ))}
                </select></td>
                </tr>
                <tr align="center">
                    <td colSpan={4}>
                        <button 
                    className="button" 
                    onClick={fetchMenuReport}
                    disabled={loading}
                >
                    {loading ? 'Loading...' : 'Submit'}
                </button>
                <button 
                    className="button" 
                    onClick={() => window.history.back}
                >
                    Back
                </button>
                    </td>
                </tr>
            </table>
            <br></br>
            <br></br>
            <br></br>
            <br></br>


            
            {loading && (
                <div className="text-center" align='center'>
                    <div className="spinner-border" role="status">
                        <CircularProgress/>
                    </div>
                </div>
            )}

            {!loading && message === 'No data available' && (
  <div align="center" style={{ color: 'darkred', fontWeight: 'bold', fontSize: '20px' }}>
    {message}
  </div>
)}
            
            
            {menus.length > 0 && (
                <div className="mt-4">
                    <table className="table table-bordered" align='center'>
                        <thead >
                            <tr className="tableheader">
                                <th colSpan={4}>FPS Device Menus {message}
                                </th>
                            </tr>
                            <tr className="tableheader">
                                <th>Sl.No</th>
                                <th>Service Link</th>
                                <th>Description</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {menus.map((menu, index) => (
                                <tr 
                                    key={menu.slno} 
                                    style={{ 
                                        backgroundColor: menu.status === 'Y' ? '#b3ffcc' : '#ffe6e6' 
                                    }}
                                >
                                    <td>{menu.slno}</td>
                                    <td>{menu.serviceName}</td>
                                    <td>{menu.menuName}</td>
                                    <td>
                                        <select
                                            className="form-control"
                                            value={menu.status}
                                            onChange={(e) => handleStatusChange(index, e.target.value)}
                                        >
                                            <option value="Y">Active</option>
                                            <option value="N">Stopped</option>
                                        </select>
                                    </td>
                                </tr>
                            ))}
                            <tr align="center">
                                <td colSpan={4}>
                                    <button 
                                        className="button" 
                                        onClick={handleSubmit}
                                    >
                                        Update Menu Status
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
            <br></br>

            <br></br>
                    
                    {updateMessage && (
                        <div align="center">
                            {updateMessage}
                        </div>
                    )}
                </div>
            )}
            <br></br>
                        <br></br>

            <br></br>

            <br></br>

            <br></br>

            <br></br>

        </div>
    );
};

export default FPSMenuDetails;